import { A7ProductionMtd, A7ProductionYtd } from '../../client'
import COLORS from '../../utils/colorScale'
import { defaultAxis, defaultConfig, layoutTemplate } from '../../utils/plotly'
import Plot from '../shared/Plot'

const ChartProductionToDate = ({
  prodToDateData,
  year,
  month,
  type,
  revision,
  plotStyle,
  isLoading,
}: {
  prodToDateData: A7ProductionMtd[] | A7ProductionYtd[]
  year: number
  month: number
  type: 'mtd' | 'ytd'
  revision: number
  plotStyle: any
  isLoading: boolean
}) => {
  if (isLoading) return null

  const x = ['Realizado', 'P50']
  const prodData =
    type === 'mtd'
      ? (prodToDateData as A7ProductionMtd[]).find(d => d.yyyy === year && d.mm === month)
      : (prodToDateData as A7ProductionYtd[]).find(d => d.yyyy === year)

  const p50 = prodData?.p50 ? prodData.p50 : 0
  const actual = prodData?.actual ? prodData.actual : 0

  const bop_parada = prodData?.bop_parada ? prodData.bop_parada / 1000 : 0
  const bop_restric = prodData?.bop_restric ? prodData.bop_restric / 1000 : 0
  const turbine_parada = prodData?.turbine_parada ? prodData.turbine_parada / 1000 : 0

  let windness = p50 - (actual + bop_parada + bop_restric + turbine_parada)
  windness = windness > 0 ? windness : 0
  windness = actual < p50 ? windness : 0
  windness = prodData?.actual ? windness : 0
  // Prior to 2025 there are no available data for windness
  windness = year >= 2025 ? windness : 0

  const data = [
    {
      ...defaultAxis,
      x,
      y: [actual, null],
      name: 'Realizado',
      type: 'bar',
      marker: { color: COLORS.verde },
      hoverinfo: 'all',
    },
    {
      ...defaultAxis,
      x,
      y: [bop_restric, null],
      name: 'Restrição ONS',
      type: 'bar',
      marker: { color: COLORS.laranja_international },
      hoverinfo: 'all',
    },
    {
      ...defaultAxis,
      x,
      y: [bop_parada, null],
      name: 'Parada BOP',
      type: 'bar',
      marker: { color: COLORS.amarelo_pantone },
      hoverinfo: 'all',
    },
    {
      ...defaultAxis,
      x,
      y: [turbine_parada, null],
      name: 'Turbine Parada',
      type: 'bar',
      marker: { color: COLORS.roxo_indigo },
      hoverinfo: 'all',
    },
    {
      ...defaultAxis,
      x,
      y: [windness, null],
      name: 'Weather+Uncertainty',
      type: 'bar',
      marker: {
        pattern: {
          shape: '/',
          bgcolor: COLORS.cinza_medio_claro,
          solidity: 0.4,
        },
        color: 'white',
      },
      hoverinfo: 'all',
    },
    {
      ...defaultAxis,
      x,
      y: [null, p50],
      xaxis: 'x2',
      name: 'P50',
      type: 'bar',
      marker: { color: COLORS.azul_pantone },
      hoverinfo: 'all',
    },
  ]
  const xaxis = {
    title: type === 'mtd' ? 'Month to Date' : 'Year to Date',
    fixedrange: true,
    linewidth: 2,
    gridwidth: 2,
  }
  const layout = {
    template: layoutTemplate,
    barmode: 'stack',
    margin: { b: 35, t: 35, l: 40, r: 10 },
    yaxis: {
      title: 'Produção [GWh]',
      fixedrange: true,
      linewidth: 2,
      gridwidth: 2,
      gridcolor: COLORS.transparent_bg,
    },
    xaxis,
    xaxis2: { ...xaxis, gridcolor: COLORS.transparent_bg, overlaying: 'x' },
    plot_bgcolor: COLORS.transparent_bg,
    showlegend: false,
    title: {
      text: `Δ ${type === 'mtd' ? 'Mês' : 'Ano'}: ${prodData?.delta_gwh} [GWh] (${
        prodData?.delta_percentage
      }%)`,
      font: { size: 14 },
    },
  }
  const style = { ...plotStyle }
  const config = {
    ...defaultConfig,
    displayModeBar: false,
  }
  return (
    <div className='pf-v5-u-p-sm'>
      <Plot
        divId='ChartProductionMonthly'
        useResizeHandler
        data={data}
        layout={layout}
        config={config}
        style={style}
        key={revision}
      />
    </div>
  )
}

export default ChartProductionToDate
